import React from "react";

import toUSD from "@src/utils/toUSD";

import styles from "./UsedBudget.module.css";

interface UsedBudgetHeaderProps {
  isLoading: boolean;
  consumedBudget: number;
  budgetMax?: number;
  maxValueClassName: string;
  progressPercent: number;
}

const UsedBudgetHeader = ({
  budgetMax,
  consumedBudget,
  isLoading,
  maxValueClassName,
  progressPercent,
}: UsedBudgetHeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <div className={styles.topContainer}>
          <div className={styles.text}>Budget Used</div>

          <div className={styles.flexRow}>
            {isLoading ? (
              <div className={styles.text}>--</div>
            ) : (
              <>
                <div className={styles.text}>{`${toUSD(consumedBudget)}`}</div>

                {budgetMax !== undefined && (
                  <div className={maxValueClassName}>{`/ ${toUSD(
                    budgetMax
                  )}`}</div>
                )}
              </>
            )}
          </div>
        </div>

        <div className={styles.progressBarContainer}>
          <div
            className={styles.progressBar}
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default UsedBudgetHeader;
